var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalProduct = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.599609 6.5V0H8.84961L9.04192 0.173077L12.7342 3.86538L12.9073 4.05769V16H0.599609V11H1.83038V14.7692H11.6765V4.92308H7.98423V1.23077H1.83038V6.5H0.599609ZM10.7919 3.69231L9.215 2.11538V3.69231H10.7919Z",
    fill: "#606B76"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63643 9.10711C8.83612 8.91113 8.83612 8.58943 8.63643 8.39344L6.10024 5.90417C5.78393 5.59372 5.25 5.8178 5.25 6.26101V7.9997H0V9.4997H5.25V11.2395C5.25 11.6827 5.78393 11.9068 6.10024 11.5964L8.63643 9.10711Z",
    fill: "#606B76"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalProduct);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-product.73cb7ca77731e82b8c74d22a3c5e0d6a.svg";